module.exports = __webpack_public_path__ + "img/detail-btn.905ed7e8.png";